// VWorld API Key
export const VWORLD_API_KEY = '680783E1-FA80-3E05-B14F-1ED8B51C3A29';
// Google API Key
export const GOOGLE_API_KEY = 'AIzaSyD0t-0fo0H04SnSxGAzeQ-0pXrkWNm2XuU';

// OpenLayers
export const OL_DEFAULT_MAP_ID = 'GOOGLE';
export const OL_DEFAULT_CENTER = { lat: 37.55, lng: 127.05 };
export const OL_DEFAULT_ZOOM = 17;
export const OL_MAX_ZOOM = 22;
export const OL_RESTRICTED_BOUNDS = {
  north: OL_DEFAULT_CENTER.lat + 0.5,
  south: OL_DEFAULT_CENTER.lat - 0.5,
  west:  OL_DEFAULT_CENTER.lng - 0.5,
  east:  OL_DEFAULT_CENTER.lng + 0.5,
};
export const OL_VWORLD_BOUNDS = {
  north: 45.0,
  south: 30.0,
  west: 116.0,
  east: 141.0,
};

// 3rd Party APIs
export const ELEVATION_BASE_URL = 'https://elevation.themobilityone.com';
export const NTRIP_BASE_URL = 'https://ntrip.themobilityone.com';
export const STREAMHUB_RTMP_URL = 'rtmp://streamhub.themobilityone.com';
export const GOOGLE_GEOCODING_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

// Mission
export const SAFETY_MARGIN = 30;

// Survey
export const SURVEY_DEFAULT_OPTIONS = {
  entryIndex: 0,
  gap: 10,
  rotate: 0,
  turnaround: { before: 0, after: 0 },
  segment: null,
  camera: null,
};
export const SURVEY_ENTRIES = [
  'bottom left',
  'top left',
  'top right',
  'bottom right',
];
export const SURVEY_GAP_MIN = 2;
export const SURVEY_GAP_MAX = 500;
export const SURVEY_TURNAROUND_MIN = 0;
export const SURVEY_TURNAROUND_MAX = 1000;
export const SURVEY_AREA_MAX = 200000000; // 200km²

// Fence
export const FENCE_CIRCLE_RADIUS_MIN = 10;
export const FENCE_POLYGON_AREA_MIN = 100; // 100m²

// Camera Shoot
export const SHOOT_OVERLAP_DEFAULT_OPTIONS = {
  forward: 10,
  side: 10,
};
export const SHOOT_OVERLAP_MIN = 0;
export const SHOOT_OVERLAP_MAX = 99;
export const SHOOT_INTERVAL = 25;

// Crypto
export const CRYPTO_SECRET_KEY = 'MOBILITY_ONE';
export const CRYPTO_SALT = 'USER_LOGIN_SALT';
export const CRYPTO_IV = 'M1UCS';

// DJI Cloud API
export const DJI_APP_ID = '172053';
export const DJI_APP_KEY = 'f8847e5cbc40aa240c27402e26dfc69';
export const DJI_APP_LICENSE = 'Fex3GhevAlGAIILcwaEEB7p3UfsxKw+bB/6BkZtKscrLZPJAqLPc17BFY3ltB/dWT7OxJ/nKxWrbkHDjteVvxtw7Z1EHFGRavBOW6hqbCh7nCcXb9KSWe3Wa4GnJ1M+lScQK35LwGFosd8qmHZze2qxWR2k7Gq4fnA/GLKaGFpg=';
